
// PRE REGISTRATION REJECTIONS
export const GET_PRE_REGISTRATION_REJECTIONS = "/pre-registration-rejections";
export const ADD_NEW_PRE_REGISTRATION_REJECTION = "/pre-registration-rejections";
export const UPDATE_PRE_REGISTRATION_REJECTION = "/pre-registration-rejections";
export const DELETE_PRE_REGISTRATION_REJECTION = "/pre-registration-rejections";


